import {
  Box,
  Flex,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tooltip,
  Tr,
} from "@chakra-ui/react";
import { Link, useParams } from "react-router-dom";
import { VENDOR_PORTAL_PATHS } from "modules/vendor-portal/paths";
import type { FeedbackLocationState } from "modules/vendor-portal/screens/feedback/feedback-screen";
import { FeedbackGroupByOption } from "modules/vendor-portal/screens/feedback/utils";
import { PIE_CHART_COLOR_MAP } from "modules/vendor-portal/screens/overview/components/listing-performance/constants";

type PieChartLegendProps = {
  interestLevelStats: { id: string; label: string; value: number }[];
  totalAttendees: number;
};
export function PieChartLegend({
  interestLevelStats,
  totalAttendees,
}: PieChartLegendProps) {
  const { regionId, propertyId } = useParams();

  return (
    <TableContainer>
      <Table size={"sm"} variant={"unstyled"}>
        <Thead bgColor={"none"}>
          <Tr>
            <Th></Th>
            <Th>
              <Text
                fontSize={"sm"}
                fontWeight={400}
                color={"gray.400"}
                textAlign={"end"}
              >
                %
              </Text>
            </Th>
            <Th>
              <Text
                fontSize={"sm"}
                fontWeight={400}
                color={"gray.400"}
                textAlign={"end"}
              >
                qty
              </Text>
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          {interestLevelStats?.map(({ id, label, value }) => (
            <Tr key={id}>
              <Td>
                <Flex direction={"row"} align={"center"} gap={4} w={"145px"}>
                  <Box
                    w={"12px"}
                    h={"12px"}
                    borderRadius={"100%"}
                    bgColor={PIE_CHART_COLOR_MAP[id]}
                  />
                  <Tooltip
                    label={"Click to view feedback"}
                    placement={"top"}
                    hasArrow
                  >
                    <Text
                      as={Link}
                      to={`/${regionId}/listing/${propertyId}/${VENDOR_PORTAL_PATHS.FEEDBACK}`}
                      state={
                        {
                          groupBy: FeedbackGroupByOption.Name,
                          showOnly: {
                            key: "interest_level",
                            value: id,
                          },
                        } satisfies FeedbackLocationState
                      }
                      fontSize={"md"}
                      fontWeight={700}
                      color={"blue.600"}
                    >
                      {label}
                    </Text>
                  </Tooltip>
                </Flex>
              </Td>
              <Td>
                <Text
                  fontSize={"md"}
                  fontWeight={500}
                  color={"gray.600"}
                  textAlign={"end"}
                >
                  {totalAttendees > 0
                    ? Math.round((value / totalAttendees) * 100)
                    : 0}
                  %
                </Text>
              </Td>
              <Td>
                <Text
                  fontSize={"md"}
                  fontWeight={500}
                  color={"gray.600"}
                  textAlign={"end"}
                >
                  {value}
                </Text>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </TableContainer>
  );
}
